import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { rightImg, watchImg } from "../utils";

import VideoCarousel from "./VideoCarousel";

const Highlights = () => {
  useGSAP(() => {
    gsap.to("#title", {
      opacity: 1,
      y: 0,
    });

    gsap.to(".link", {
      opacity: 1,
      y: 0,
      duration: 1,
      stagger: 0.25,
    });
  }, []);

  return (
    <section
      id="highlights"
      className="w-full overflow-hidden min-h-screen common-padding scroll-smooth bg-zinc-900 text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        {/* Title and Links Section */}
        <div id="projects" className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-12 w-full">
          <h1
            id="title"
            className="section-heading text-3xl md:text-5xl font-bold mt-10 leading-tight"
          >
            My Projects
          </h1>

          <div className="flex flex-wrap items-center gap-4">
            {/* Optional second link kept commented if needed */}
            {/* 
            <p className="link flex items-center text-sm md:text-base cursor-pointer hover:underline transition-all">
              Watch the film
              <img src={watchImg} alt="watch" className="ml-2 w-4 h-4" />
            </p> 
            */}
            <p className="link flex items-center text-sm md:text-base cursor-pointer hover:underline transition-all">
              Explore Github
              <img src={rightImg} alt="right" className="ml-2 w-4 h-4" />
            </p>
          </div>
        </div>

        {/* Video Carousel Section */}
        <VideoCarousel />
      </div>
    </section>
  );
};

export default Highlights;